import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import FileTag from "./FileTag";

const FileInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    fullCol,
    required,
  } = item;

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData
      : [
          {
            label: label,
            type: "file",
            name: "",
            defaultValue: "",
          },
        ]
  );

  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "file",
        name: "",
        defaultValue: "",
      },
    ]);
  };

  const handleRemoveElement = (index) => {
    // console.log(quantityCount);
    // const newArray = quantityCount.splice(index, 1);
    // console.log(newArray);
  };

  return (
    <div
      className={
        fullCol
          ? `col-span-3 flex flex-col gap-2 ${
              quantityCount?.length > 0 ? "items-end" : "items-start"
            } w-full fitHeight`
          : `flex flex-col gap-2 ${
              quantityCount?.length > 0 ? "items-end" : "items-start"
            } w-full fitHeight`
      }
    >
      <label className="font-semibold self-start">{label}</label>
      <div className={fullCol ? "grid grid-cols-3 gap-3 w-full " : " w-full "}>
        {multipleData ? (
          quantityCount.map((item, index) => (
            <FileTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              handleRemoveElement={handleRemoveElement}
            />
          ))
        ) : (
          <FileTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            handleRemoveElement={handleRemoveElement}
          />
        )}
      </div>

      {multiple && (
        <div className={`flex justify-center items-end`}>
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default FileInput;
